import React from "react";

export default function About() {
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-24" data-testid="about-page">
      <p className="label-eyebrow">About</p>
      <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-[0.9] mt-3 max-w-3xl">
        One plaza built around seven daily essentials.
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-20">
        <div className="md:col-span-7 text-base leading-relaxed text-black/80 space-y-6">
          <p>
            Twinstars Plaza is a multi-service lifestyle and hospitality destination. We bring together a boxing arena, a wellness spa, a fully-equipped gym, a guesthouse, a barbing salon, a washing bay and a laundry — all under one roof.
          </p>
          <p>
            Every visit, every booking, every payment lives in one account. Your wallet earns across the plaza and spends across the plaza. Our staff are vetted, our facilities maintained to hospitality-grade standards, and our doors open 24/7.
          </p>
          <p>
            We're also a major employer — eleven staff roles open at any time, from spa therapists to security officers, from supervisors to personal assistants.
          </p>
        </div>
        <aside className="md:col-span-5 space-y-6">
          <div className="border border-black p-6">
            <p className="label-eyebrow">Address</p>
            <p className="font-display font-bold text-lg mt-2">Twinstars Plaza<br/>Accra, Ghana</p>
          </div>
          <div className="border border-black p-6">
            <p className="label-eyebrow">Hours</p>
            <p className="font-display font-bold text-lg mt-2">24 / 7</p>
            <p className="text-sm text-black/60 mt-2">Laundry pickup: Tuesdays · Delivery: Saturdays</p>
          </div>
          <div className="border border-black p-6">
            <p className="label-eyebrow">Contact</p>
            <p className="font-display font-bold text-lg mt-2">info@twinstarsgh.com</p>
            <p className="text-sm text-black/60 mt-2">+233 24 000 0000</p>
          </div>
        </aside>
      </div>
    </div>
  );
}
